import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "../../core/util/helper.js";
import { Assignment, Resource, SplittingDialogWrapperStaticData } from "./splittingDialogTypes.js";
import React from "react";

interface ResultViewProps {
    resultData: StringKeyDictionary<Assignment[]>;
    staticData: SplittingDialogWrapperStaticData;
}

export class ResultView extends React.Component<ResultViewProps, any>{
    private root: HTMLDivElement;

    private renderChildItem = (event: any) => {
        const item: TreeItem = {
            id: event.IsGuid,
            expanded: true,
            items: [],
            type: "child",
            event: this.mapToEventInfo(event)
        };
        return item;
    }

    private renderParentItem = (id: string) => {
        const data = this.props.resultData[id];
        const item: TreeItem = {
            id: id,
            expanded: true,
            items: data.map(this.renderChildItem),
            type: "parent",
            event: this.mapToEventInfo(this.props.staticData.assignmentData[id].Assignment)
        };
        return item;
    }

    private mapToEventInfo = (assignment: Assignment) => {
        const result = assignment as EventInfo;
        result.IsContainer = Helper.isNullOrEmpty(assignment.ResNo);
        if (result.IsContainer) {
            result.ContainerName = this.props.staticData.containers.find(item => item.Value == assignment.GrNr).Name
        } else {
            result.Resource = this.props.staticData.resource;
        }
        return result;
    }

    private mapToTreeItems = () => {
        return Object.keys(this.props.resultData).filter(id => Helper.hasValue(this.props.staticData.assignmentData[id]) && id != this.props.staticData.splittingAssignment.IsGuid).map(this.renderParentItem);
    }

    componentDidMount() {
        const parentTemplate = kendo.template(this.props.staticData.templates.parent);
        const childTemplate = kendo.template(this.props.staticData.templates.child);
        $(this.root).kendoTreeView({
            dataSource: this.mapToTreeItems(),
            template: (dataItem: { item: TreeItem }) => {
                const data = dataItem.item;
                if (data.type == "parent") {
                    return parentTemplate({ event: data.event, items: this.props.resultData[data.id].map(this.mapToEventInfo) })
                } else {
                    return childTemplate({ event: data.event})
                }
            }
        })
    }

    render() {
        return <div style={{ height: "100%" }} ref={(ref) => { this.root = ref; }}></div>;
    }
}


interface TreeItem {
    id: string;
    expanded: boolean;
    items: TreeItem[];
    type: "parent" | "child";
    event?: EventInfo;
}

interface EventInfo extends Assignment {
    IsContainer: boolean;
    ContainerName: string;
    Resource: Resource;
}